module.exports = __webpack_public_path__ + "img/modulos_sait.177458ab.jpg";